// export const DEV = process.env.NODE_ENV === 'development';
export const ENV_PROD = false;
export const ENV_DEV = true;
export const ENV_TEST = false;
export const LOG_ENABLED = true;

export const RECAPTCHA_ENABLED = false;
export const RECAPTCHA_PUBLIC_KEY = '';

// Local Server
export const BASE_URL = 'https://qis-test.dae.gov.bd';
export const API_GATEWAY_URL = 'https://test-apigateway-qis.dae.gov.bd/';
export const CDN_URL = 'https://test-cdn-qis.dae.gov.bd/';
export const MEDIA_SOURCE = 'https://test-cdn-qis.dae.gov.bd/image/';
export const WEB_SOCKET_URL = 'https://test-websocket-qis.dae.gov.bd/';

export const SECURITY_UI_URL = 'https://qis-test.dae.gov.bd';
export const ADMIN_UI_URL = 'https://qis-test.dae.gov.bd';
export const USER_PANEL_UI_URL = 'https://qis-test.dae.gov.bd';

export const AUTH_SERVER_PREFIX = "auth";
export const CDN_SERVER_PREFIX = "cdn";
export const UTIL_SERVER_PREFIX = "util";
export const CORE_SERVER_PREFIX = "qis";
export const QIS_SERVER_PREFIX = "qis";
export const FMIS_SERVER_PREFIX = "fmis";
export const PMIS_SERVER_PREFIX = "pmis";
